// extracted by mini-css-extract-plugin
export default {"warningWrapper":"AudienceWarningMessage_warningWrapper__U0ac-","expandedMessage":"AudienceWarningMessage_expandedMessage__9CSzh"};